import { useState } from 'react';

import type { ContactDto } from '../../api/types';
import type { BadgeChannelType } from '../dialogs/ChannelBadge';
import { cn } from '../../lib/cn';
import { stagePalette } from '../../lib/stage-colors';
import { KanbanCard } from './KanbanCard';

export interface KanbanColumnProps {
  stage: string;
  label: string;
  contacts: ContactDto[];
  onDragStart: (e: React.DragEvent, contact: ContactDto) => void;
  onDrop: (stage: string) => void;
  onCardClick: (contact: ContactDto) => void;
  channelTypeById: Record<string, BadgeChannelType>;
}

export function KanbanColumn({ stage, label, contacts, onDragStart, onDrop, onCardClick, channelTypeById }: KanbanColumnProps) {
  const [over, setOver] = useState(false);
  const palette = stagePalette(stage);

  return (
    <div
      data-testid={`kanban-column-${stage}`}
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        onDrop(stage);
      }}
      className={cn(
        'flex w-64 shrink-0 flex-col rounded border',
        over ? 'border-primary bg-primary/5' : cn(palette.border, palette.bg),
      )}
    >
      <div className={cn('flex items-center gap-1.5 border-b px-3 py-2 text-sm font-semibold', palette.border, palette.text)}>
        <span className={cn('h-1.5 w-1.5 rounded-full', palette.dot)} />
        {label} <span className="text-xs font-normal text-muted-fg">({contacts.length})</span>
      </div>
      <div className="flex-1 space-y-2 overflow-y-auto p-2">
        {contacts.map((c) => (
          <KanbanCard
            key={c.id}
            contact={c}
            onDragStart={onDragStart}
            onClick={onCardClick}
            channelType={c.sourceChannelId ? channelTypeById[c.sourceChannelId] : undefined}
          />
        ))}
        {contacts.length === 0 && <div className="p-2 text-center text-xs text-muted-fg">Пусто</div>}
      </div>
    </div>
  );
}
